import { nonNegativeInteger, nonNegativeNumber, postiveNumberZeroToOneHundred } from "@/utils/form";
import { z } from "zod";
import { t } from "i18next";

export const ServiceAdvancedCostParametersSchema = z.object({
  averageHoursWorkedPerMonth: nonNegativeInteger(t("edittender.defaults.inputs.averagehoursworkedpermonth.label")),
  trainingDays: nonNegativeInteger(t("edittender.defaults.inputs.trainingdays.label")),
  yearlyTrainingCosts: nonNegativeNumber(t("edittender.defaults.inputs.yearlytrainingcosts.label")),
  sickDays: nonNegativeInteger(t("edittender.defaults.inputs.sickdays.label")),
  employeeFluctuation: postiveNumberZeroToOneHundred(t("edittender.defaults.inputs.employeefluctuation.label")),
  yearlyUniformCosts: nonNegativeNumber(t("edittender.defaults.inputs.yearlyuniformcosts.label")),
  otherMaterialCosts: nonNegativeNumber(t("edittender.defaults.inputs.othermaterialcosts.label")),
  averageLengthOfEmployment: nonNegativeInteger(t("edittender.defaults.inputs.averagelengthofemployment.label")),
  carCostsPerMinute: nonNegativeNumber(t("edittender.defaults.inputs.carcostsperminute.label")),
  otherCostsPerMinute: nonNegativeNumber(t("edittender.defaults.inputs.othercostsperminute.label")),
});

export const ServiceAdvancedCostParametersDefaultValues = {
  averageHoursWorkedPerMonth: 0,
  trainingDays: 0,
  yearlyTrainingCosts: 0,
  sickDays: 0,
  employeeFluctuation: 0,
  yearlyUniformCosts: 0,
  otherMaterialCosts: 0,
  averageLengthOfEmployment: 0,
  carCostsPerMinute: 0,
  otherCostsPerMinute: 0,
};

export type TServiceAdvancedCostParametersSchema = z.infer<typeof ServiceAdvancedCostParametersSchema>;
